import { InsightsAccordionItem, InsightsAccordionKeys } from './types';

export const INSIGHTS_ACCORDION_ITEMS: InsightsAccordionItem[] = [
  { value: 'Активные', key: InsightsAccordionKeys.active },
  { value: 'Архив', key: InsightsAccordionKeys.archive },
];
